import axios from "axios";
import { getAccessToken } from "../infrastructure/teams";
import errorHandler from "./errorHandler";

const service = axios.create();

service.interceptors.request.use(
  async (config) => {
    const token = await getAccessToken();
    config.headers.common["Authorization"] = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    errorHandler(error);
    return Promise.reject(error);
  }
);

export default service;
